import { css, keyframes } from 'styled-components';

// =============================================================================
// Colors
// =============================================================================

export const POOL_STATUS_COLORS = {
  inHitZone: '#1ab232',
  winAnyMoment: '#ff7226',
  aboutToBlow: '#ff3826',
} as const;

// =============================================================================
// Animation Timings
// =============================================================================

export const ANIMATION_TIMING = {
  slow: '1.8s',
  fast: '0.9s',
} as const;

// =============================================================================
// Keyframes
// =============================================================================

export const blinkBadge = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
`;

export const blinkShadowOrange = keyframes`
  0%, 100% { box-shadow: 0 0 20px 1px rgba(255, 114, 38, 0.5); }
  50% { box-shadow: 0 0 20px 1px rgba(255, 114, 38, 0.2); }
`;

export const blinkShadowRed = keyframes`
  0%, 100% { box-shadow: 0 0 20px 1px rgba(255, 56, 38, 0.5); }
  50% { box-shadow: 0 0 20px 1px rgba(255, 56, 38, 0.2); }
`;

export const blinkPrizeSlow = keyframes`
  0%, 100% {
    color: #fff8d5;
    text-shadow: 0 0 10px #f57832;
  }
  50% {
    color: #fff;
    text-shadow: none;
  }
`;

export const blinkPrizeFast = keyframes`
  0%, 100% {
    color: #fceea9;
    text-shadow: 0 0 10px #f57832;
  }
  50% {
    color: #fff;
    text-shadow: none;
  }
`;

// =============================================================================
// Shared Badge Styles
// =============================================================================

export const badgeBaseStyles = css`
  display: inline-flex;
  padding: 2px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  color: ${({ theme }) => theme.whiteColor};
  font-size: 10px;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0;
`;

// =============================================================================
// Status Mixins (for banner/dark background)
// =============================================================================

export const bannerStatusStyles = css`
  &.inHitZone .badge {
    background: ${POOL_STATUS_COLORS.inHitZone};
  }

  &.winAnyMoment .badge {
    background: ${POOL_STATUS_COLORS.winAnyMoment};
    animation: ${blinkBadge} ${ANIMATION_TIMING.slow} ease-in-out infinite;
  }

  &.winAnyMoment .prize {
    animation: ${blinkPrizeSlow} ${ANIMATION_TIMING.slow} ease-in-out infinite;
  }

  &.aboutToBlow .badge {
    background: ${POOL_STATUS_COLORS.aboutToBlow};
    animation: ${blinkBadge} ${ANIMATION_TIMING.fast} ease-in-out infinite;
  }

  &.aboutToBlow .prize {
    animation: ${blinkPrizeFast} ${ANIMATION_TIMING.fast} ease-in-out infinite;
  }
`;

// =============================================================================
// Status Mixins (for card/light background)
// =============================================================================

export const cardStatusStyles = css`
  &.inHitZone .badge {
    background: ${POOL_STATUS_COLORS.inHitZone};
  }

  &.winAnyMoment {
    border: 1px solid ${POOL_STATUS_COLORS.winAnyMoment};
    box-shadow: 0 0 20px 1px rgba(255, 114, 38, 0.5);
    animation: ${blinkShadowOrange} ${ANIMATION_TIMING.slow} ease-in-out infinite;

    & .badge {
      background: ${POOL_STATUS_COLORS.winAnyMoment};
      animation: ${blinkBadge} ${ANIMATION_TIMING.slow} ease-in-out infinite;
    }
  }

  &.aboutToBlow {
    border: 1px solid ${POOL_STATUS_COLORS.aboutToBlow};
    box-shadow: 0 0 20px 1px rgba(255, 56, 38, 0.5);
    animation: ${blinkShadowRed} ${ANIMATION_TIMING.fast} ease-in-out infinite;

    & .badge {
      background: ${POOL_STATUS_COLORS.aboutToBlow};
      animation: ${blinkBadge} ${ANIMATION_TIMING.fast} ease-in-out infinite;
    }
  }
`;
